/**
 * configuration redux reducer
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


import {
    UPDATE_CONFIGURATION, LOAD_USER_SETTINGS, CHANGE_USER_SETTING
} from "./consts";


const initialState = {
    active: {
        defaultLanguage: "de",
        fallbackLanguages: ["en", "de"],
        logReduxActions: false,
        logReduxState: false,
        theme: "musos"
    },
    parameterMap: {},
    userSettings: {
        fields: {}
    }
};

function createParameterMap(parameters) {
    let result = {};
    for (const item of parameters) {
        result[item.fields.key] = item.fields.value;
    }
    return result;
}

export default function configurationReducer(state = initialState, action) {

    switch (action.type) {

        case UPDATE_CONFIGURATION: {

            const configuration = {
                ...state.active,
                ...action.configuration
            };

            return {
                ...state,
                active: configuration,
                parameterMap: createParameterMap(configuration.parameters || [])
            };
        }

        case LOAD_USER_SETTINGS: {

            return {
                ...state,
                userSettings: action.settings
            };
        }

        case CHANGE_USER_SETTING: {
            return {
                ...state,
                userSettings: {
                    ...state.userSettings,
                    fields: {
                        ...state.userSettings.fields,
                        [action.fieldId]: action.value
                    }
                }
            };
        }

        default:
            return state;
    }
}
